export default __webpack_public_path__ + "static/media/dragon5.d1aea6ed.jpg";